import timeoutProm from "utils/promise/promiseTimeout";
import { WAIT_FOR_EVENT_SUBSCRIBE, WAIT_FOR_EVENT_UNSUBSCRIBE } from "actions/actionTypes";
import store from "store/configureStore";
import { findFirstCandidate } from "../functions";
import { errorEvents } from "constants/errorEventTypes";
import { env } from "../env";

const getCorrelationIdEvents = (state, correlationId) => state.serverEvents[correlationId];

const waitForEventSubscribeAction = correlationId => ({ type: WAIT_FOR_EVENT_SUBSCRIBE, payload: { correlationId } });
const waitForEventUnsubscribeAction = correlationId => ({
  type: WAIT_FOR_EVENT_UNSUBSCRIBE,
  payload: { correlationId }
});

const endWaitForEvent = (unsubscribe, correlationId) => () => {
  store.dispatch(waitForEventUnsubscribeAction(correlationId));
  if (unsubscribe) unsubscribe();
};

const waitForEvent = (correlationId, eventNames = [], timeout = env.REACT_APP_HTTP_TIMEOUT) => {
  store.dispatch(waitForEventSubscribeAction(correlationId));
  let unsubscribe;

  const matchEvents = events => {
    if (events && events.length) {
      const requestedEvent = findFirstCandidate(events, eventNames, (e, en) => e.eventType === en);
      const errorEvent = findFirstCandidate(events, errorEvents, (e, ee) => e.eventType.indexOf(ee) > -1);
      if (requestedEvent) {
        return { ...requestedEvent, ok: true };
      } else if (errorEvent) {
        return { ...errorEvent, ok: false };
      } else if (eventNames.length === 0) {
        return { ...events[0], ok: true };
      }
    }
    return false;
  };

  let previousEvents = getCorrelationIdEvents(store.getState(), correlationId);
  let prom = new Promise((resolve, _reject) => {
    const matchedEvent = matchEvents(previousEvents);
    if (matchedEvent) {
      resolve(matchedEvent);
      return;
    }
    unsubscribe = store.subscribe(() => {
      const events = getCorrelationIdEvents(store.getState(), correlationId);

      if (events && events.length) {
        if (previousEvents && previousEvents.length !== events.length) {
          const matchedEvent = matchEvents(events);
          if (matchedEvent) {
            resolve(matchedEvent);
          }
        }
      }

      previousEvents = events;
    });
  });

  return timeoutProm(prom, endWaitForEvent(unsubscribe, correlationId), timeout, correlationId, eventNames);
};

export default waitForEvent;

export class EventError extends Error {
  event;
  constructor(message, event = {}) {
    super(message);
    Object.setPrototypeOf(this, EventError.prototype);

    this.event = event;
  }
}
